export default __webpack_public_path__ + "static/media/livingroom4.640ea831.webp";